import bemMixin from 'framework/mixins/bem';


export default {
    mixins: [
        bemMixin('media-portal-item', { useProp: false }),
    ],
    props: {
        isActive: {
            type: Boolean,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            wasActivated: false,
        };
    },
    computed: {
        content() {
            return this.item.content;
        },
        facet() {
            return this.item.facet;
        },
    },
    watch: {
        isActive: {
            handler(val) {
                if (!val) {
                    return;
                }

                this.wasActivated = true;
            },
            immediate: true,
        },
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/mixins/media-portal-item/index.js